import moment from 'moment';

export type GraphBucketType = 'hour' | 'day';

/**
 * Device-local wall-clock as UTC epoch ms (Y/M/D/H/M/S from the device clock,
 * stamped via Date.UTC). Passed to GetCasinoInsightGraph so Hour 1 / Day 1 axis
 * slots match the phone clock; FE still formats buckets with moment.utc.
 */
export const clientLocalNowAsUtcMs = (d = new Date()): number =>
  Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

/**
 * Hour buckets read "3 PM"; day buckets read "Oct 5".
 * Graph axis buckets are device-local wall-clock stamped with a Z suffix —
 * format in UTC so "19:00Z" shows as 7 PM (the intended local hour).
 */
export const formatBucketLabel = (bucket: string, bucketType: GraphBucketType): string =>
  bucketType === 'hour' ? moment.utc(bucket).format('h A') : moment.utc(bucket).format('MMM D');

/** Most tick labels shown on the x axis; 30 day bars stay readable. */
export const MAX_GRAPH_TICKS = 7;

/**
 * Buckets that get a tick label: every `step`-th bucket, always including the
 * last one (the most recent bar), so at most MAX_GRAPH_TICKS (+1) labels.
 */
export const pickTickBuckets = (buckets: string[], maxTicks = MAX_GRAPH_TICKS): Set<string> => {
  const n = buckets.length;
  const step = Math.max(1, Math.ceil(n / Math.max(1, maxTicks)));
  const out = new Set<string>();
  buckets.forEach((b, i) => {
    if ((n - 1 - i) % step === 0) out.add(b);
  });
  return out;
};
